import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import LanguageSwitcher from './LanguageSwitcher'
import Menu from './Menu'

function Navbar() {
  const { t } = useTranslation()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 991)
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <nav className="menu_topbar">
      {isMobile ? (
        <>
          <Menu showLanguageSwitcher={true} />
          <div className="logo_container">
            <a href="/">
              <img src="/assets/images/branding/logos/logo.png" alt="logo" />
            </a>
          </div>
          <div className="mobile_lang_switcher">
            <LanguageSwitcher isMobile={true} />
          </div>
        </>
      ) : (
        <>
          <div className="nav_links left-links">
            <a href="/" className="marcellus">
              {t('home')}
            </a>
            <a href="/about" className="marcellus">
              {t('nav.about')}
            </a>
            <a href="/gallery" className="marcellus">
              {t('nav.gallery')}
            </a>
            <a href="/custom" className="marcellus">
              {t('custom')}
            </a>
          </div>

          <div className="logo_container">
            <a href="/">
              <img src="/assets/images/branding/logos/logo.png" alt="logo" />
            </a>
          </div>

          <div className="nav_links right-links">
            <a href="/contact" className="marcellus">
              {t('nav.contact')}
            </a>
            <a href="#" className="marcellus" onClick={() => alert(t('shopComingSoon'))}>
              {t('shop')}
            </a>
            <LanguageSwitcher />
          </div>
        </>
      )}
    </nav>
  )
}

export default Navbar
